import { render, staticRenderFns } from "./WarrantyTypeField.vue?vue&type=template&id=bd0644bc&scoped=true"
import script from "./WarrantyTypeField.vue?vue&type=script&setup=true&lang=ts"
export * from "./WarrantyTypeField.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WarrantyTypeField.vue?vue&type=style&index=0&id=bd0644bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0644bc",
  null
  
)

export default component.exports